<div *ngIf="carregando" class="oferta-carregando">
  <span class="eyebrow">Oferta {{ nomePlano }}</span>
  <div class="flex gap-5 items-center flex-wrap">
    <div class="cartao-esqueleto"><span class="cartao-marca">{{ nomePlano }}</span></div>
    <div class="flex-1 flex flex-col gap-2" style="min-width: 220px">
      <p class="frase-carregando" aria-live="polite">{{ frasesCarregando[fraseAtual] }}</p>
      <span class="barra-esqueleto" style="width: 70%"></span>
      <span class="barra-esqueleto" style="width: 45%"></span>
    </div>
  </div>
</div>

<ng-container *ngIf="elegivel && familia as f">

  <!-- ── Oferta ─────────────────────────────────────────────── -->
  <div *ngIf="etapa === 'oferta'" class="oferta-card">
    <div class="flex items-center justify-between gap-3 flex-wrap">
      <span class="eyebrow">Oferta {{ nomePlano }}</span>
      <!-- Só indica a sequência: trocar de plano é pelo "Recusou", que registra a recusa -->
      <div class="trilho" data-teste="sequencia-planos">
        <span *ngFor="let p of familias; let i = index" class="aba"
              [class.aba-ativa]="i === idx" [class.aba-recusada]="recusados.has(i)" [attr.aria-current]="i === idx ? 'step' : null">
          <span class="ponto" [style.background-color]="corDe(p).fundo"></span>{{ nomeCurto(p.nome) }}
        </span>
      </div>
    </div>

    <div class="flex gap-5 flex-wrap items-center">
      <div class="cartao-plano" [style.background-color]="cor.fundo" [style.color]="cor.texto"
           [style.box-shadow]="'0 14px 28px -16px ' + cor.sombra">
        <span class="cartao-marca">{{ nomePlano }}</span>
        <span class="cartao-nome">{{ nomeCurto(f.nome) }}</span>
      </div>
      <div class="flex-1" style="min-width: 230px">
        <p class="hero-titulo" *ngIf="comparativo?.economia; else semEconomia">
          Economize <span style="color: #0E7A53">{{ comparativo!.economia | brl }}</span> hoje
        </p>
        <ng-template #semEconomia><p class="hero-titulo">{{ f.nome }}</p></ng-template>
        <p class="hero-sub">
          <ng-container *ngIf="comparativo?.economia">
            {{ procedimentos.length === 1 ? 'Procedimento' : 'Atendimento' }} de
            <s>{{ comparativo!.semPlano | brl }}</s> por <b>{{ comparativo!.comPlano | brl }}</b>.
          </ng-container>
          Plano <b class="valor">{{ opcao?.valor | brl }}{{ ciclo === 'anual' ? '/ano' : '/mês' }}</b>.
        </p>
      </div>
    </div>

    <!-- Beneficios da praca, do catalogo da marca; sem catalogo para a familia, a secao some -->
    <div *ngIf="f.beneficios.length || f.beneficiosAusentes?.length" class="flex flex-col gap-2">
      <span class="rotulo">Benefícios do {{ nomeCurto(f.nome) }}</span>
      <ul class="beneficios">
        <li *ngFor="let b of f.beneficios">
          <span class="check" [style.background-color]="cor.fundo" [style.color]="cor.texto">✓</span>{{ b }}
        </li>
        <li *ngFor="let b of f.beneficiosAusentes ?? []" class="ausente">
          <span class="check check-ausente">✕</span><s>{{ b }}</s>
        </li>
      </ul>
      <p *ngFor="let nota of f.notas" class="nota">{{ nota }}</p>
    </div>

    <!-- Pagamento antes do termo: escolhe ciclo e vencimento, depois manda o termo -->
    <div class="pagamento">
      <span class="rotulo">Pagamento</span>
      <div class="pagamento-linha">
        <div class="trilho">
          <button *ngIf="f.mensal as m" type="button" class="segmento" [class.segmento-ativo]="ciclo === 'mensal'"
                  [attr.aria-pressed]="ciclo === 'mensal'" (click)="ciclo = 'mensal'">
            Mensal <span class="valor">{{ m.valor | brl }}</span>
          </button>
          <button *ngIf="f.anual as a" type="button" class="segmento" [class.segmento-ativo]="ciclo === 'anual'"
                  [attr.aria-pressed]="ciclo === 'anual'" (click)="ciclo = 'anual'">
            Anual <span class="valor">{{ a.valor | brl }}</span>
          </button>
        </div>
        <div *ngIf="ciclo === 'mensal' && opcao?.aceitaVencimento" class="vencimento">
          <span class="rotulo">Vencimento</span>
          <div class="trilho">
            <button *ngFor="let d of DIAS_VENCIMENTO" type="button" class="segmento" [class.segmento-ativo]="diaVencimento === d"
                    [attr.aria-pressed]="diaVencimento === d" (click)="diaVencimento = d">dia {{ d }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Termo de adesao: canal escolhido antes de enviar, com o destino ja mascarado -->
    <div class="termo">
      <div class="flex items-center justify-between gap-2 flex-wrap">
        <span class="rotulo">Termo de adesão</span>
        <span *ngIf="!termoLiberado" class="text-xs" style="color: var(--brand-muted)">A cobrança libera quando o paciente assinar</span>
      </div>

      <div *ngIf="!termoLiberado" class="canais" role="radiogroup" aria-label="Canal do termo">
        <div *ngFor="let c of canais" class="canal" role="radio"
             [class.canal-ativo]="canalEscolhido === c.id" [attr.aria-checked]="canalEscolhido === c.id"
             [class.canal-inativo]="!destinoDe(c.id) && editandoCanal !== c.id"
             (click)="destinoDe(c.id) && editandoCanal !== c.id && !isEnviandoTermo ? canalEscolhido = c.id : null">
          <span class="canal-radio"></span>
          <span class="flex flex-col min-w-0 text-left flex-1">
            <span class="canal-nome">
              {{ c.nome }}
              <span *ngIf="contatoFoiEditado(c.id)" class="canal-editado">corrigido</span>
            </span>
            <ng-container *ngIf="editandoCanal !== c.id">
              <span class="canal-destino">{{ destinoDe(c.id) ? formatarDestino(c.id, destinoDe(c.id)) : c.semContato }}</span>
            </ng-container>
            <div *ngIf="editandoCanal === c.id" class="canal-edicao" (click)="$event.stopPropagation()">
              <input [(ngModel)]="valorEdicao" [attr.inputmode]="c.id === 'sms' ? 'numeric' : 'email'"
                     [placeholder]="c.id === 'sms' ? '(85) 99999-9999' : 'email@paciente.com'"
                     (keydown.enter)="salvarContato()" (keydown.escape)="cancelarEdicao()" />
              <button type="button" class="link" (click)="salvarContato()">Salvar</button>
              <button type="button" class="link link-neutro" (click)="cancelarEdicao()">Cancelar</button>
            </div>
            <span *ngIf="editandoCanal === c.id && erroEdicao" class="canal-erro">{{ erroEdicao }}</span>
          </span>
          <button *ngIf="editandoCanal !== c.id" type="button" class="link canal-editar"
                  [disabled]="isEnviandoTermo" (click)="$event.stopPropagation(); editarContato(c.id)">
            {{ destinoDe(c.id) ? 'Editar' : 'Informar' }}
          </button>
        </div>
      </div>

      <p class="termo-status" aria-live="polite">
        <ng-container *ngIf="termoLiberado">
          <span class="status-ok">✓</span>
          <ng-container *ngIf="termoImportado as importado; else assinado">
            Termo assinado importado (PDF) em {{ importado.enviadoEm | date: 'dd/MM HH:mm' }}
          </ng-container>
          <ng-template #assinado>Termo assinado em {{ termo!.assinadoEm | date: 'dd/MM HH:mm' }}</ng-template>
        </ng-container>
        <ng-container *ngIf="!termoLiberado && termoEnviadoPara as enviado">
          <span class="status-ok">✓</span>
          Enviado por {{ enviado.canal === 'sms' ? 'SMS' : 'e-mail' }} para {{ formatarDestino(enviado.canal, enviado.destino) }}
          às {{ enviado.em | date: 'HH:mm' }}. Aguardando o paciente assinar ·
          <button type="button" class="link" [disabled]="verificandoTermo" (click)="verificarTermo()">
            {{ verificandoTermo ? 'Verificando...' : 'Verificar assinatura' }}
          </button> ·
          <button type="button" class="link" [disabled]="isEnviandoTermo || !destinoDe(canalEscolhido)"
                  (click)="enviarTermo(canalEscolhido)">
            {{ isEnviandoTermo ? 'Reenviando...' : 'Reenviar' + (canalEscolhido !== enviado.canal ? ' por ' + (canalEscolhido === 'sms' ? 'SMS' : 'e-mail') : '') }}
          </button>
        </ng-container>
        <ng-container *ngIf="!termoLiberado && !termoEnviadoPara && envioAnterior as anterior">
          <span class="status-ok">✓</span>
          Termo enviado às {{ anterior.enviadoEm | date: 'HH:mm' }}. Aguardando o paciente assinar ·
          <button type="button" class="link" [disabled]="verificandoTermo" (click)="verificarTermo()">
            {{ verificandoTermo ? 'Verificando...' : 'Verificar assinatura' }}
          </button>
        </ng-container>
        <ng-container *ngIf="!termoLiberado && !termoEnviadoPara && !envioAnterior">
          Envie o termo e peça para o paciente assinar no celular; a cobrança libera quando a assinatura chegar.
        </ng-container>
      </p>

      <div *ngIf="!termoLiberado" class="termo-importar">
        <input #arquivoTermo type="file" accept="application/pdf" hidden (change)="importarTermo($event)" />
        <button *ngIf="opcao" type="button" class="link" (click)="baixarTermoModelo()" [disabled]="baixandoModelo">
          {{ baixandoModelo ? 'Baixando…' : 'Baixar termo para preencher' }}
        </button>
        <span>Assinou no papel?</span>
        <button type="button" class="link" [disabled]="isImportandoTermo" (click)="arquivoTermo.click()">
          {{ isImportandoTermo ? 'Importando termo...' : 'Importar termo assinado (PDF)' }}
        </button>
      </div>
    </div>

    <div class="rodape">
      <div class="acoes-oferta">
        <button type="button" class="btn-recusou" data-teste="recusou" (click)="recusar()">
          <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="m7 7 6 6M13 7l-6 6"/></svg>
          {{ proximoNaoRecusado !== null ? 'Recusou, oferecer ' + nomeCurto(familias[proximoNaoRecusado].nome) : 'Paciente recusou' }}
        </button>
        <button *ngIf="!termoLiberado && termoEnviadoPara" type="button" class="btn btn-accent" disabled
                title="A cobrança libera quando o paciente assinar o termo">
          Aguardando assinatura...
        </button>
        <button *ngIf="!termoLiberado && !termoEnviadoPara" type="button" class="btn btn-accent"
                [disabled]="isEnviandoTermo || !destinoDe(canalEscolhido)" (click)="enviarTermo(canalEscolhido)">
          {{ isEnviandoTermo ? 'Enviando termo...' : (envioAnterior ? 'Reenviar' : 'Enviar') + ' termo por ' + (canalEscolhido === 'sms' ? 'SMS' : 'e-mail') }}
        </button>
        <button *ngIf="termoLiberado" type="button" class="btn btn-sucesso" (click)="irParaCobranca()">
          Cobrar <span class="valor">{{ opcao?.valor | brl }}</span>
        </button>
      </div>
    </div>

  </div>

  <!-- ── Cobrança ───────────────────────────────────────────── -->
  <div *ngIf="etapa === 'cobranca'" class="cobranca-card">
    <div class="cobranca-header" [style.background-color]="cor.fundo" [style.color]="cor.texto">
      <div class="min-w-0">
        <p class="cobranca-titulo">{{ f.nome }} · {{ ciclo === 'anual' ? 'Anuidade' : '1ª mensalidade' }}</p>
        <p class="cobranca-sub">{{ ciclo === 'anual' ? 'Pagamento único · válido por 12 meses' : 'Mensal · próximas vencem todo dia ' + diaVencimento }}</p>
      </div>
      <span class="cobranca-valor valor">{{ valorCobranca | brl }}</span>
    </div>

    <app-cobranca-sim [acoes]="acoesAdesao" [valor]="valorCobranca" [guiche]="guiche" [aceitaPix]="aceitaPix"
                      [podeEnviarLink]="!!cliente?.id" [cobrancaCriada]="temAssinatura"
                      [checkoutLiberado]="termoLiberado && !!cliente?.id"
                      [cartaoHabilitado]="!!opcao?.cartaoPaymentMethodId" [maxParcelas]="opcao?.maxParcelas ?? 1"
                      [contatosCheckout]="{ email: destinoDe('email'), whatsapp: destinoDe('sms') ? formatarDestino('sms', destinoDe('sms')) : '' }"
                      [rodape]="origem ? 'O plano só é ativado depois que a cobrança for aprovada.' : 'O atendimento segue como particular até a cobrança ser aprovada.'"
                      (voltar)="voltarParaOferta()" (semResposta)="onMaquininhaSemResposta()"></app-cobranca-sim>
  </div>

  <!-- ── Pago ───────────────────────────────────────────────── -->
  <div *ngIf="etapa === 'pago'" class="faixa-final">
    <div class="bloco-plano" [style.background-color]="cor.fundo" [style.color]="cor.texto">
      <span class="cartao-marca">{{ nomePlano }}</span><span class="font-extrabold text-lg">{{ nomeCurto(f.nome) }}</span>
    </div>
    <div class="p-4 min-w-0">
      <p class="font-bold" style="color: var(--tx)">Paciente agora é assinante</p>
      <p class="text-xs" style="color: var(--brand-text-soft)">
        <span class="valor">{{ valorCobranca | brl }}</span> aprovado{{ pagoNa ? ' na ' + pagoNa : pagoNoCheckout ? ' no cartão de crédito' : ' no PIX' }}
        <ng-container *ngIf="comparativo?.economia"> · desconto de <span class="valor">{{ comparativo!.economia | brl }}</span> aplicado</ng-container>
      </p>
    </div>
  </div>

  <!-- ── Recusado ───────────────────────────────────────────── -->
  <div *ngIf="etapa === 'recusado'" class="faixa-recusa">
    <span class="flex gap-1">
      <span *ngFor="let p of familias" class="quadrado" [style.background-color]="corDe(p).fundo"></span>
    </span>
    <span class="flex-1 text-sm" style="color: var(--brand-text-soft)">
      {{ nomesDosPlanos }} recusados · registrado no relatório de conversão.
    </span>
    <button type="button" class="link" (click)="desfazerRecusa()">Desfazer</button>
  </div>

  <p *ngIf="erro && etapa === 'oferta'" class="text-xs mt-2" style="color: #B4003C">{{ erro }}</p>
</ng-container>
